import $ from 'jquery';
import { displayLoader, hideLoader } from 'plugins/loader';
import fetch from 'utils/fetch';
import { error as toastError, success as toastSuccess } from 'plugins/toastr';

export function index() {
  handleFiles();
}

function handleFiles() {
  const $input = $('#UploadFileInput');
  const $button = $('#UploadFileButton');

  $('#UploadFileButton').on('click', evt => {
    $input.trigger('click');
  });

  const url = $button.attr('data-url');

  $input.on('change', event => {
    const file = event.target.files[0];

    if (file) {
      const fd = new FormData();
      fd.append('file', file);

      displayLoader();
      fetch(url, {
        method: 'POST',
        body: fd,
      })
        .then(res => {
          toastSuccess('Le fichier a été téléchargé avec succès');
          hideLoader();
          return res.text();
        })
        .then(refreshFilesTable, error => {
          hideLoader();
          toastError('Une erreur est survenue pendant la sauvegarde.');
        });
    }
  });

  bindDeletion();
}

export function refreshFilesTable(content) {
  const filesList = document.getElementById('FilesList');
  filesList.innerHTML = content;

  bindDeletion();
}

function bindDeletion() {
  $('#FilesList .fileRow .button.delete').on('click', evt => {
    evt.preventDefault();

    const $button = $(evt.currentTarget);
    const url = $button.attr('data-url');

    if (url) {
      $('.modal.delete')
        .modal({
          onApprove: element => {
            displayLoader();
            fetch(url, { method: 'DELETE' })
              .then(res => {
                $('.modal.delete').modal('hide');
                hideLoader();
                return res.text();
              })
              .then(
                res => {
                  toastSuccess('Le fichier a été supprimé');
                  refreshFilesTable(res);
                },
                error => {
                  hideLoader();
                  toastError('Une erreur est survenue pendant la suppression.');
                }
              );
            return false;
          },
        })
        .modal('show');
    }
  });
}



// WEBPACK FOOTER //
// ./src/modules/saas/entity/index.js